<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>{{ user?.name }}</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="showChampionForm()">
    <mat-icon>emoji_events</mat-icon>
  </button>
</mat-toolbar>

@if (user) {
  <div class="poll-champion-bar" (click)="showChampionForm()">
    <div class="champ-left">
      @if (currentTimestamp >= firstRoundIniTimestamp && user.team) {
        <img class="champ-flag" [src]="user.team.flag" [alt]="user.team.name" />
      } @else {
        <div class="champ-icon-wrap"><mat-icon>emoji_events</mat-icon></div>
      }
      <div class="champ-details">
        <span class="champ-title">Campeón &amp; Pichichi</span>
        <span class="champ-sub">
          @if (currentTimestamp >= firstRoundIniTimestamp) {
            @if (user.team) {
              {{ user.team.name }}
            } @else {
              Sin seleccionar
            }
            @if (user.pichichi) {
              · ⚽ {{ user.pichichi }}
            }
          } @else {
            Toca para configurar
          }
        </span>
      </div>
    </div>
    <mat-icon class="champ-arrow">chevron_right</mat-icon>
  </div>
}

<div class="poll-content">
  @if (user) {
    <app-matches-list
      [hidden]="!pollProcessed"
      [mode]="matchesViewMode"
      [user]="user"
      (roundChanged)="onRoundChanged($event)"
    ></app-matches-list>
  }
</div>

@if (isAdmin || (currentRoundIniTimestamp > currentTimestamp && isMe)) {
  <div class="poll-save-bar">
    <button class="save-btn" (click)="update()">
      <mat-icon>save</mat-icon>
      Guardar pronósticos
    </button>
  </div>
}

<block-ui></block-ui>
